import _ from "lodash";

import DebugLogger from "../../utils/DebugLogger";
import MessageBox from "../ui/MessageBox";
import BaseView from "./BaseView";
import { StatusBar } from 'react-native';

class BaseComponent extends BaseView {
    get reducer() {
        throw new Error("Not implemented.");
    }

    get actionHandlers() {
        return {};
    }

    get supportOffline() {
        return false;
    }

    constructor(props) {
        super(props);

        DebugLogger.log("Lifecycle: " + this.viewName + " is created.");

        if (this.reducer) {
            DebugLogger.log("Lifecycle: register reducer for " + this.viewName);

            this.reducer.register();
        }
    }

    componentDidMount() {
        super.componentDidMount();

        DebugLogger.log("Lifecycle: " + this.viewName + " is mounted.");
    }

    componentDidUpdate(prevProps) {
        if (prevProps.localState && this.props.localState) {
            // var preAction = prevProps.localState.action;
            var curAction = this.props.localState.action;
            if (curAction) {
                var preAction = prevProps.localState.executedActions ? prevProps.localState.executedActions[curAction.type] : null;
                if (preAction && curAction) {
                    if (curAction.isDone) {
                        if (!preAction.isDone) {
                            if (this.componentHandleActionDone) {
                                this.componentHandleActionDone(curAction, this.props);
                            }
                        }
                    } else if (curAction.error) {
                        if (!preAction.error) {
                            if (this.componentHandleActionError) {
                                this.componentHandleActionError(curAction, this.props);
                            }
                        }
                    }
                }
            }
        }

        // we only process the error one time
        // handle general errors for now
        // if there are no general errors, but only action errors,
        // we will not need this part of logic any more
        if (!prevProps.localState.error && this.props.localState.error) {
            if (this.componentHandleError) this.componentHandleError(this.props.localState.error, this.props);
        }
    }

    componentWillUnmount() {
        if (this.reducer) {
            DebugLogger.log("Lifecycle: unregister reducer for " + this.viewName);

            this.reducer.unregister();
        }

        DebugLogger.log("Lifecycle: " + this.viewName + " is destroyed.");
    }

    componentHandleActionDone(action, props) {
        if (!_.isEmpty(action.type)) {
            if (this.actionHandlers[action.type]) {
                if (this.actionHandlers[action.type].done) {
                    this.actionHandlers[action.type].done(action, props);
                }
            }
        }
    }

    componentHandleActionError(action, props) {
        if (!_.isEmpty(action.type)) {
            if (this.actionHandlers[action.type]) {
                if (this.actionHandlers[action.type].error) {
                    this.actionHandlers[action.type].error(action, props);
                } /*else {
                    //by default, we will display a message box for this
                    try {
                        this.displayError(action.error);
                    } catch (e) {}
                }*/
            } else {
                //by default, we will display a message box for this
                try {
                    this.displayError(action.error);
                } catch (e) {}
            }
        }
    }

    getExecutedAction(actionType) {
        if (this.props && this.props.localState && this.props.localState.executedActions) {
            return this.props.localState.executedActions[actionType];
        }

        return null;
    }

    isActionExecuting(actionType) {
        if (this.props && this.props.localState && this.props.localState.executedActions) {
            var action = this.props.localState.executedActions[actionType];
            return action ? action.isExecuting : false;
        }

        return false;
    }

    isActionDone(actionType) {
        if (this.props && this.props.localState && this.props.localState.executedActions) {
            var action = this.props.localState.executedActions[actionType];
            return action ? action.isDone : false;
        }

        return false;
    }

    displayError(error, onClose) {
        if (!error) {
            return; // do nothing
        }

        let options = {
            text: error.message,
            position: "top",
            duration: 15000,
        };

        // android当状态栏透明时, 错误提示会被状态栏文字盖住
        options.style = {
            //position: 'absolute',
            top: StatusBar.currentHeight,
        };

        if (_.isFunction(onClose)) {
            options = { ...options, onClose };
        }

        MessageBox.danger(options);
    }

    displayInfo(info, onClose) {
        if (!info) {
            return; // do nothing
        }

        let options = {
            text: info.message,
            position: "top",
            duration: 5000,
        };
        options.style = {
            //position: 'absolute',
            top: StatusBar.currentHeight,
        };
        if (_.isFunction(onClose)) {
            options = { ...options, onClose };
        }

        MessageBox.success(options);
    }
}

export default BaseComponent;
